<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for -->
  <div v-if="$SO.size(userPhotos)" class="user-photos">
    <h4 class="user-photos__heading">User Photos ({{ totalUserPhoto }})</h4>
    <ul class="list-user-photo">
      <li
        v-for="(userReviewImage, key) in userPhotos"
        v-if="key < 7"
        :key="key"
        @click.prevent="openModalUserPhotos(key)"
      >
        <img
          :src="mainImage(userReviewImage.url) || ''"
          width="80"
          height="80"
          class="list-user-photo__img"
          alt="icon-loader"
          loading="lazy"
          @error="imageErrorHandler($event)"
        />
        <div v-if="key === 6" class="list-user-photo__last-child">
          <p class="list-user-photo__last-child-text">See all<br />{{ totalUserPhoto }} <br />photos</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'user-photos',
  computed: {
    totalUserPhoto() {
      return this.$store.state.productDetail.totalUserPhoto;
    },
    userPhotos() {
      return this.$store.state.productDetail.userPhotos;
    },
  },
  methods: {
    openModalUserPhotos(key) {
      this.$store.commit('setModalUserPhotos', true);
      this.$store.commit('setInitialIndexSlide', key);
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=80' : 'w=90',
        image: src,
      });
    },
    imageErrorHandler(e) {
      e.target.src = '/assets/img/broken-img-review.png';
    },
  },
};
</script>
